import { render, staticRenderFns } from "./InstitutionalQnrResultsIPS.vue?vue&type=template&id=01aee73b&scoped=true&"
import script from "./InstitutionalQnrResultsIPS.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrResultsIPS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aee73b",
  null
  
)

export default component.exports